// extracted by mini-css-extract-plugin
module.exports = {"pinInputs":"_17gAekZo"};